import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import { Loading, Page, SubNavigation } from '@fielded/shared-ui'

import { usePageLoading } from '../../../../../van-shared/hooks/pageLoading'
import { getNavigationItem } from '../../../../../common/utils/navigationInfo'
import PSMShipmentExportImportDownload from './PSMShipmentExportImportDownload'
import PSMShipmentExportImportUpload from './PSMShipmentExportImportUpload'

export const VIEW_TYPES = {
  DOWNLOAD: 'download',
  UPLOAD: 'upload'
}

const getSubNavigationItems = (view, mainPathname) => {
  // We are getting the pathname from history since the url can differ depending if the user is viewing this page from Stock Transfer or Outbound Shipments
  // TODO: Replace with correct url after these are merged
  return [
    {
      title: 'Download template',
      path: `${mainPathname}/${VIEW_TYPES.DOWNLOAD}`,
      active: !view || view === VIEW_TYPES.DOWNLOAD
    },
    {
      title: 'Upload shipment',
      path: `${mainPathname}/${VIEW_TYPES.UPLOAD}`,
      active: view === VIEW_TYPES.UPLOAD
    }
  ]
}

const PSMShipmentExportImport = ({
  isUploading,
  onUpload,
  onCancel,
  onError,
  config,
  country,
  view,
  mainPathname,
  documentFormRef,
  warehouseCode,
  facilitiesExamples,
  productExamples,
  handleExcelTemplateDownload,
  handleCSVTemplateDownload,
  isCSVTemplateDownloading,
  isExcelTemplateDownloading
}) => {
  const { isPageLoading } = usePageLoading()
  const subNavigationItems = getSubNavigationItems(view, mainPathname)

  return (
    <Page withFixedFooter>
      <Page.ComposableHeader>
        <Page.ComposableHeader.Breadcrumb
          items={[getNavigationItem({ item: 'shipments', config, includePath: false })]}
        />
        <Page.ComposableHeader.Content spread>
          <Page.ComposableHeader.Title title={'Outbound Shipments'} />
        </Page.ComposableHeader.Content>
      </Page.ComposableHeader>
      <Page.Panel narrow alignLeft>
        <aside>
          <SubNavigation
            className='last-mile-deliveries__sub-nav vs-u-align-end'
            label=''
            items={subNavigationItems}
            linkRenderer={({ key, to, className, children }) => (
              <Link
                key={key}
                to={to}
                className={className}
              >
                {children}
              </Link>
            )}
          />
        </aside>
      </Page.Panel>
      {isPageLoading ? (
        <Loading />
      ) : (
        <Fragment>
          {!view || view === VIEW_TYPES.DOWNLOAD ? (
            <PSMShipmentExportImportDownload
              warehouseCode={warehouseCode}
              facilitiesExamples={facilitiesExamples}
              productExamples={productExamples}
              country={country}
              app={config.app}
              isExcelTemplateDownloading={isExcelTemplateDownloading}
              isCSVTemplateDownloading={isCSVTemplateDownloading}
              handleExcelTemplateDownload={handleExcelTemplateDownload}
              handleCSVTemplateDownload={handleCSVTemplateDownload}
            />
          ) : (
            <Page.Panel narrow alignLeft>
              <PSMShipmentExportImportUpload
                documentFormRef={documentFormRef}
                isUploading={isUploading}
                onUpload={onUpload}
                onCancel={onCancel}
              />
            </Page.Panel>
          )}
        </Fragment>
      )}
    </Page>
  )
}

export default PSMShipmentExportImport
